import { Api } from './api';
import { OnboardingStatus } from '../types/onboarding';

const api = new Api({
  baseURL: process.env.TALKVISOR_API_URL,
  withCredentials: true,
})

export { OnboardingStatus };

export const getOnboardingStatus = async () => {
  const res = (await api.v1.getAccount('me')).data;

  const crawledValues = [
    res.website_details?.background_color,
    res.website_details?.button_background_color,
    res.website_details?.button_text_color,
    res.website_details?.logo,
    res.website_details?.text_color,
    res.website_details?.text_content,
  ];

  // If the above values are all null/undefined, the website is not crawled yet.
  if (crawledValues.every((v) => !v)) {
    return OnboardingStatus.CRAWLING_WEBSITE;
  }

  if (!res.automation_settings?.bot_context_form?.store_explanation) {
    return OnboardingStatus.ANALYZING_WEBSITE;
  }

  return OnboardingStatus.DONE;
};